import React, { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";
import { formatValue } from "../../../utils/currencyUtils";

const OutboundOrderHeader = ({ hProps }) => {
  const [orderDetails, setOrderDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});

  const fieldLabels = {
    erpOrderType: "ERP Order Type",
    lmd: "LMD",
    totalWeightUom: "Total Weight UOM"
  };

  useEffect(() => {
    // Keys to always show under "Order"
    const orderKeys = [
      "orderNo",
      "customer",
      "customerName",
      "supplier",
      "supplierName",
      "shipTo",
      "shipToSite",
      "shipToOwner",
      "orderType",
      "processType",
      "erpOrderType",
      "totalWeightOrder",
      "totalWeightUom"
    ];

    // Keys to always show under "Payment"
    const paymentKeys = [
      "creationDate",
      "createdBy",
      "headerState",
      "billTo",
      "billToDescription",
      "soldTo",
      "soldToDescription",
      "lmd",
    ];

    // Helper to seed object with default values
    const seedWithDefaults = (src, keys) =>
      keys.reduce((acc, k) => {
        acc[k] = src?.[k] ?? null;
        return acc;
      }, {});

    const orderObj = seedWithDefaults(hProps || {}, orderKeys);
    const paymentObj = seedWithDefaults(hProps || {}, paymentKeys);

    const orderDetails = {
          ...orderObj,
          totalWeightOrder: formatValue(hProps.totalWeightOrder),
        };

    setOrderDetails(orderDetails);
    setPaymentDetails(paymentObj);
  }, [hProps]);


  return (
    <UpperLayerTabLayout
      firstHeading="Order"
      secondHeading="Payment"
      firstBoxData={orderDetails}
      secondBoxData={paymentDetails}
      title="Sales Orders Detail"
      showThirdTab={false}
      showTrackAndTrace={false}
      fieldLabels={fieldLabels}
    />
  );
};

export default OutboundOrderHeader;
